module.exports = __webpack_public_path__ + "img/TBANK.4450160d.png";